import { GameType } from "@apiserver-rest/ponder-data-client-base";
import { UserHistoryComponent } from "./user-history.component";

export function getHistoryRoute(game: GameType, start: number, startDate?: Date, endDate?: Date, name?: string, exactName?: boolean) : string {
    var route = `/history?${UserHistoryComponent.QueryParamGame}=${game}&${UserHistoryComponent.QueryParamStart}=${start}`;

    if (startDate) { route += `&${UserHistoryComponent.QueryParamStartDate}=${startDate!}`; }
    if (endDate) { route += `&${UserHistoryComponent.QueryParamEndDate}=${endDate!}`; }
    if (name) { route += `&${UserHistoryComponent.QueryParamName}=${name!}`; }
    if (exactName) { route += `&${UserHistoryComponent.QueryParamExactName}=${exactName!}`; }

    return route;
}